export class Category {
    uuid: string;
    category: string;
    image: string;
}
